<template>
  <div class="main-authentication">
    <div class="login-box box-auth">

      <img v-if="monenco" src="@/assets/images/monencogroup-logo.png" alt="logo">
      <img v-else src="@/assets/images/logo.png" alt="logo">
      <div class="title">
        <router-link to="/auth/login"><i class="fa-regular fa-arrow-right"></i> بازگشت</router-link>

        <h2 class="w-100">رمز عبور را وارد کنید</h2>
      </div>

      <div class="input input-pass " :class="{'error':error}">
        <label>
          گذرواژه
        </label>
        <input @keydown.enter="submit" :type="showPass ? 'text':'password'" v-model="password">
        <i @click="showPass = !showPass" class="fa-regular"
           :class=" !showPass ? 'fa-eye-slash' : 'fa-eye'"
        ></i>
      </div>
      <div v-if="error" class="error-box text-danger">گذرواژه وارد شده اشتباه است.</div>
      <!--      <div class="forget-link">
              <router-link to="/auth/forget-password">فراموشی رمز عبور</router-link>
            </div>-->
      <div class="input captcha mt-0">
        <label>
          کد کپچا
        </label>
        <input @keydown.enter="submit" type="text" v-model="captcha"/>
        <img @click="getCaptcha" :src="captchaImg" alt="">

      </div>
      <v-btn @click="submit" :loading="loading" class="btn btn-save">تایید</v-btn>
      <div class="separator"></div>
      <router-link v-if="getOtpEnabled == '1'" class="btn disposable" to="/auth/otp"> ورود با رمز یکبار مصرف <i class="fa fa-angle-left"></i>
      </router-link>

    </div>

  </div>
</template>

<script>


import axios from "axios";
import store from "@/store";
import Cookies from "js-cookie";

export default {
  name: "PasswordComponent",
  data() {
    return {
      apiUrl: store.getters.baseUrl,
      apiUrl2: store.getters.baseUrl2,
      apiBaseUrl: window.appConfig.API_URL_BASE,
      monenco: window.appConfig.monenco,
      showPass: false,
      captchaImg: '',
      error: false,
      captcha: '',
      password: '',
      mobile: '',
      loading: false,
      snackbar: false,
      textSnack: '',
      colorSnack: '',
      headers: {
        'Accept': 'Application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    };
  },
  methods: {
    getCaptcha() {
      this.mobile = store.getters.getMobile
      this.captcha = ''
      if (store.getters.getMobile === '') {
        this.$router.push('/auth/login')
      }
      axios.post(this.apiBaseUrl + 'api/captcha', {username: this.mobile}, {headers: this.headers})
          .then(res => {
            this.captchaImg = res.data.captcha_image
          })


    },
    setCookie(token) {

      Cookies.set('token', token, {expires: 7, path: '/'});
    },
    submit() {
      if (this.password === '' || this.captcha === '') {
        this.showMsg('لطفا موارد را به درستی وارد کنید!', 'red')
        return
      }

      this.loading = true

      let body = {
        username: this.mobile,
        password: this.password,
        captcha: this.captcha.toLowerCase(),
      }
      axios.post(this.apiBaseUrl + 'api/login', body, {headers: this.headers})
          .then(res => {
            this.loading = false

            let token = res.data.access_token
            this.setCookie(token)

            this.getUser(token)


          }).catch(err => {
        this.loading = false
        this.getCaptcha()
        let status = err?.response?.status
        let msg = err?.response?.data.message
        if (status === 401 || status === 403) {
          this.showMsg(msg, 'red')
          return;
        }
        if (status === 422) {
          this.showMsg(msg, 'red')
         if(err?.response?.data?.password_must_change){
           this.$router.push('/auth/choice-password')
         }
          return;
        }
        if (!err?.response) {
          this.showMsg('اینترنت خود را بررسی کرده و مجدد  تلاش کنید!', 'red')
          return
        }
        this.showMsg('مشکلی پیش آمده', 'red')
      })
    },
    getUser(token) {
      let url = this.apiBaseUrl + 'api/users/get-user'
      this.headers['Authorization'] = 'Bearer ' + token
      axios.get(url, {headers: this.headers}).then(res => {
        let data = JSON.stringify(res.data)
        const permissionsSystem = res.data?.data?.permissions.some(item => item.category === "system")
        if (res.data.data.main_user === 1 || permissionsSystem) {

          this.$router.push('/')
        } else {
          this.$router.push('/management/dashboard')
        }

        localStorage.setItem('userInfo', data)
        this.getLicenseFeatures(token)

      })
    },
    getUserShift(userInfo){
      let url = this.apiBaseUrl + 'api/shift-users/get-user-shift'
      axios.get(url,
          {headers: this.headers}).then(res => {
        let cartables = [];
        let seen = new Set();

        res.data.data.forEach(item => {
          item.cartables.forEach(x => {
            if (!seen.has(x.value)) {
              seen.add(x.value);
              cartables.push(x);
            }
          });
        });
        userInfo.data.cartables = cartables


        localStorage.setItem('userInfo', JSON.stringify(userInfo))
        this.$store.dispatch('updateUserData', JSON.stringify(userInfo));
        store.commit('setLogin', true);
        store.commit('setLogout', false);

      })
    },
    getLicenseFeatures(token) {
      let url = this.apiBaseUrl + 'api/license/get-license-features'
      this.headers['Authorization'] = 'Bearer ' + token
      axios.get(url, {headers: this.headers})
          .then(res => {
        let features = res?.data?.features
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        userInfo.data.features = features

        this.getUserShift(userInfo)

      })
    },
    showMsg(msg, color) {
      this.$store.dispatch("snackbar/show", {
        text: msg,
        color: color
      })
    },

  },
  computed:{
    getOtpEnabled() {
      return this.$store.getters.getOtpEnabled;
    },

  },

  mounted() {
    this.getCaptcha()
  }
};
</script>

<style scoped lang="scss">

.main-authentication {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .separator {
    width: 150px;
    height: 1px;
    background: #EDEEF1;
    margin: 20px auto;
  }

  .forget-link {
    text-align: left;

    a {
      color: #3300CC;
    }
  }

  .box-auth {
    max-width: 440px;
    width: 100%;
    padding: 2rem 20px;
    border-radius: 32px;
    background: #fff;
    box-shadow: 0 0 10px #ccc;
  }

  .input-pass {
    position: relative;

    i {
      position: absolute;
      letter-spacing: 10px;
      bottom: 27px;
      left: 25px;
      cursor: pointer;
    }
  }

  .login-box {
    text-align: center;

    > img {
      margin: 20px auto 3rem;
    }

    h2 {
      text-align: right;
      font-size: 24px;
      margin-bottom: 10px;
    }

    span {
      font-size: 14px;
      text-align: right;
      color: #1F2937;
      width: 100%;
      display: block;
    }

    .input {
      width: 100%;
      max-width: none;
      margin-top: 15px;
      padding: 10px 0;

      input {
        direction: rtl;
      }

      label {
        text-align: right;
        font-size: 16px;
      }

      &.captcha {
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        input {
          width: calc(100% - 140px);
        }

        img {
          width: 130px;
          object-fit: contain;
          margin: 0 10px 0 0;
          cursor: pointer;
        }
      }
    }

    .btn {
      background: #24272D;
      width: 100%;
      border-radius: 99px;
      margin-top: 20px;
      color: #fff;
      padding: 10px;
      font-size: 14px;

      &.disposable {
        background: transparent;
        border: 1px solid #24272D;
        color: #24272D;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          margin-right: 10px;
        }
      }
    }
  }


}


</style>
